// extracted by mini-css-extract-plugin
export default {"customButton":"Button_customButton__amojh","cancelButton":"Button_cancelButton__E0a1k"};